import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__guest",
  "use": "icon__guest-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__guest\"><title>Artboard</title><path d=\"M21 24H3a1 1 0 0 1-1-1v-.667c0-4.148 3.08-7.763 7.177-8.933C6.72 12.312 5 9.855 5 7c0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4C18.92 14.57 22 18.185 22 22.333V23a1 1 0 0 1-1 1zM17 7c0-2.757-2.243-5-5-5S7 4.243 7 7s2.243 5 5 5 5-2.243 5-5zm-5 8c-4.215 0-7.794 3.173-7.991 7h15.982c-.197-3.827-3.776-7-7.991-7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol